/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApiUser } from './ApiUser';
import {
    ApiUserFromJSON,
    ApiUserFromJSONTyped,
    ApiUserToJSON,
} from './ApiUser';
import type { AssignmentRuleScope } from './AssignmentRuleScope';
import {
    AssignmentRuleScopeFromJSON,
    AssignmentRuleScopeFromJSONTyped,
    AssignmentRuleScopeToJSON,
} from './AssignmentRuleScope';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';
import type { SourceTag } from './SourceTag';
import {
    SourceTagFromJSON,
    SourceTagFromJSONTyped,
    SourceTagToJSON,
} from './SourceTag';

/**
 * 
 * @export
 * @interface AssignmentRule
 */
export interface AssignmentRule {
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    id: string;
    /**
     * 
     * @type {AssignmentRuleScope}
     * @memberof AssignmentRule
     */
    scope: AssignmentRuleScope;
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    source_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    connector?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    owner_user_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignmentRule
     */
    liaison_user_ids: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AssignmentRule
     */
    priority: number;
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    created_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentRule
     */
    updated_at?: string;
    /**
     * 
     * @type {SourceTag}
     * @memberof AssignmentRule
     */
    facility?: SourceTag;
    /**
     * 
     * @type {Source}
     * @memberof AssignmentRule
     */
    source?: Source;
    /**
     * 
     * @type {ApiUser}
     * @memberof AssignmentRule
     */
    owner_user?: ApiUser;
    /**
     * 
     * @type {ApiUser}
     * @memberof AssignmentRule
     */
    created_by_user?: ApiUser;
    /**
     * 
     * @type {Array<ApiUser>}
     * @memberof AssignmentRule
     */
    liaison_users?: Array<ApiUser>;
}

/**
 * Check if a given object implements the AssignmentRule interface.
 */
export function instanceOfAssignmentRule(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "scope" in value;
    isInstance = isInstance && "owner_user_id" in value;
    isInstance = isInstance && "liaison_user_ids" in value;
    isInstance = isInstance && "priority" in value;
    isInstance = isInstance && "created_by_user_id" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function AssignmentRuleFromJSON(json: any): AssignmentRule {
    return AssignmentRuleFromJSONTyped(json, false);
}

export function AssignmentRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignmentRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'scope': AssignmentRuleScopeFromJSON(json['scope']),
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'source_id': !exists(json, 'source_id') ? undefined : json['source_id'],
        'connector': !exists(json, 'connector') ? undefined : json['connector'],
        'owner_user_id': json['owner_user_id'],
        'liaison_user_ids': json['liaison_user_ids'],
        'priority': json['priority'],
        'created_by_user_id': json['created_by_user_id'],
        'created_at': json['created_at'],
        'updated_at': !exists(json, 'updated_at') ? undefined : json['updated_at'],
        'facility': !exists(json, 'facility') ? undefined : SourceTagFromJSON(json['facility']),
        'source': !exists(json, 'source') ? undefined : SourceFromJSON(json['source']),
        'owner_user': !exists(json, 'owner_user') ? undefined : ApiUserFromJSON(json['owner_user']),
        'created_by_user': !exists(json, 'created_by_user') ? undefined : ApiUserFromJSON(json['created_by_user']),
        'liaison_users': !exists(json, 'liaison_users') ? undefined : ((json['liaison_users'] as Array<any>).map(ApiUserFromJSON)),
    };
}

export function AssignmentRuleToJSON(value?: AssignmentRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'scope': AssignmentRuleScopeToJSON(value.scope),
        'facility_id': value.facility_id,
        'source_id': value.source_id,
        'connector': value.connector,
        'owner_user_id': value.owner_user_id,
        'liaison_user_ids': value.liaison_user_ids,
        'priority': value.priority,
        'created_by_user_id': value.created_by_user_id,
        'created_at': value.created_at,
        'updated_at': value.updated_at,
        'facility': SourceTagToJSON(value.facility),
        'source': SourceToJSON(value.source),
        'owner_user': ApiUserToJSON(value.owner_user),
        'created_by_user': ApiUserToJSON(value.created_by_user),
        'liaison_users': value.liaison_users === undefined ? undefined : ((value.liaison_users as Array<any>).map(ApiUserToJSON)),
    };
}

